import { copy } from "clipboard";

export default function summaryClipboard() {
  return {
    success: false,

    async handleClick() {
      await this.copyToClipboard()

      this.showSuccess()
    },

    async copyToClipboard() {
      const type = "text/html";
      const textSource = this.textSource();
      const clipboardItemData = {
        [type]: textSource,
      };
      const clipboardItem = new ClipboardItem(clipboardItemData);

      await navigator.clipboard.write([clipboardItem]);
    },

    showSuccess() {
      this.success = true
      setTimeout(() => this.success = false, 1500)
    },

    textSource() {
      const textSource = this.$refs.textSource.cloneNode(true);
      textSource.querySelectorAll("div").forEach(el => {
        el.replaceWith(...el.childNodes)
      })
      return textSource.innerHTML
    },
  }
}
